var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLogoutRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32.5H16V15.5H32V32.5Z",
    stroke: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7063 24.2063C32.0969 23.8156 32.0969 23.1813 31.7063 22.7906L27.7063 18.7906C27.3156 18.4 26.6812 18.4 26.2906 18.7906C25.9 19.1813 25.9 19.8156 26.2906 20.2063L28.5844 22.5H22C21.4469 22.5 21 22.9469 21 23.5C21 24.0531 21.4469 24.5 22 24.5H28.5844L26.2906 26.7937C25.9 27.1844 25.9 27.8188 26.2906 28.2094C26.6812 28.6 27.3156 28.6 27.7063 28.2094L31.7063 24.2094V24.2063ZM21 18.5C21.5531 18.5 22 18.0531 22 17.5C22 16.9469 21.5531 16.5 21 16.5H19C17.3438 16.5 16 17.8438 16 19.5V27.5C16 29.1562 17.3438 30.5 19 30.5H21C21.5531 30.5 22 30.0531 22 29.5C22 28.9469 21.5531 28.5 21 28.5H19C18.4469 28.5 18 28.0531 18 27.5V19.5C18 18.9469 18.4469 18.5 19 18.5H21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoutRed);
export default __webpack_public_path__ + "static/media/ic_logout_red.e6a760befd4a2df003645236fe8ae8fb.svg";
export { ForwardRef as ReactComponent };